import React, {useState,useEffect } from "react";

import { Table, } from "react-bootstrap";

import { toast } from "react-toastify";
import ApiService from '../../../services/ApiService';
import { formatPrice } from '../../../utils/helper';
import Paginator from "../../../components/Paginator"; 


const ListPayment = () => {
  const [payments, setPayments] = useState([]);
  const [pagination, setPagination] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const currency = process.env.REACT_APP_CURRENCY;

  const [apiData, setApiData] = useState({
      search: "",
      page: 0
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    ListPayments();
  }, [apiData.page, apiData.search]);

  const ListPayments = async () => {
    try {
      setIsLoader(true);
      const response = await ApiService.request({
        method: 'GET',
        url: `payments`, // Replace with your API endpoint
        params: apiData
      });
      const data = response.data;
      if (data.status) {
        setPayments(data.data.payments);
        setPagination(data.data.pagination);
      } else {
        toast.error(data.message);
      }
      setIsLoader(false);
    } catch (error) {
      setIsLoader(false);
    }
  };
  const handlePageChange = (event) => {
    setApiData(prev => ({ ...prev, page: event }));
  };
  


  return (
    <div>
      <div className="real-estate-dashboard">
        <div className="d-flex justify-content-between align-items-center rounded estate-search-bar mt-5">
          <h5 className="p-3 bg-white w-100">Payments</h5> 
        </div>
      </div>
      <div className="table-estate p-3 mt-3 rounded bg-white">
      {isLoader && <p className="text-center"><span class="spinner-border spinner-border-sm "></span> Loading</p> }

        <Table responsive striped hover className="estate-table mt-3">
          <thead>
            <tr>
              <th>Trx_id</th>
              <th>Payment For</th>
              <th>Details</th>
              <th>Amount</th>
              <th>Status</th>
              <th >Date</th>
            </tr>
          </thead>
          <tbody>
            {payments.length > 0 ? payments.map((payment) => (
              <tr key={payment.id}>
                <td>{ payment.transaction_id}</td>
                <td>{payment.pay_for }</td>
                <td>
                    {payment.pay_for === 'subscription' &&
                          <span>
                          {payment.data["name"]} <br />
                            Duration: {payment.data["duration"]+" "+payment.data["duration_type"]}
                          </span>
                              
                      }
                      {payment.pay_for === 'interview' &&
                          <span className='text-center'>
                              {/* <img src={payment.data['thumbnail']} alt="thumbnail" className='w-50px h-50px rounded' />  */}
                              {payment.data["title"]} <br />
                              Duration: {payment.data["duration"]+" "+payment.data["duration_type"]}
                          </span>
                      }
                </td>
                <td>  {currency} {formatPrice(payment.amount)}   </td>
                <td>  {payment.pay_status}   </td>
                <td className="ltr">{payment.created_at}</td>
               
              
              </tr>
            )) : (
              <tr>
                  <td colSpan="11" className="text-dark text-center mt-2">No Data Found!</td>
              </tr>
          )}
          </tbody>
        </Table>
              {pagination.total_pages > 1 && (
                  <Paginator
                      page={pagination.current_page}
                      rows={pagination.per_page}
                      totalRecords={pagination.total_records}
                      onPageChange={handlePageChange}
                  />
              )}
      </div>
    </div>
  );
};

export default ListPayment;
